import styled from "@emotion/styled";
import { FadeInContent } from "./FadeInContent";

const ImageWrapper = styled.div`
  background-image: url(/selected/GWA00038.jpeg);
  background-size: cover;
  background-position: center bottom;
  background-repeat: no-repeat;
  padding-top: 70px;
  height: 767px;
  /* max-height: 100vh; */
  width: 100%;
   @media (max-width: 748px) {
    /* height: -webkit-fill-available;
    height: fill-available;
    height: calc(var(--vh, 1vh) * 100); */
    height: 700px;
  }
  width: 100%;
`;

const Container = styled.div`
  width: 100%;
   @media (max-width: 748px) {
    /* height: -webkit-fill-available;
    height: fill-available;
    height: calc(var(--vh, 1vh) * 100); */
    padding-bottom: 40px;
  }

`;

const Texts = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export function Bye() {


  return (
    <Container>
      <ImageWrapper>
        <Texts>
          
         <FadeInContent>
            
               4월 22일 저녁 6시 30분 

               <br/>
               
               플로팅 아일랜드에서 만나요~❤️
            
         </FadeInContent>
        </Texts>
      </ImageWrapper>
    </Container>
  );
}
